import SolicitacaoDoacaoRealizadas from './componentes/SolicitacaoDoacaoRealizadas.vue';
import SolicitacaoDoacaoRealizadasLista from './componentes/SolicitacaoDoacaoRealizadasLista.vue';

export default {
  path: '/solicitacao-doacao-realizadas',
  component: SolicitacaoDoacaoRealizadas,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoDoacaoRealizadasLista,
      name: 'solicitacao-doacao-realizadas',
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-doacao-realizadas/rotas.js